import React, { useEffect, useState } from "react";
import { api } from "@/lib/api";
import PlantCard from "@/components/PlantCard";
import AddCustomPlantDialog from "@/components/AddCustomPlantDialog";
import { useNavigate, Link } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { toast } from "sonner";

const EMPTY_BG = "https://images.pexels.com/photos/5040995/pexels-photo-5040995.jpeg?auto=compress&w=1200&q=80";

export default function Garden() {
  const [plants, setPlants] = useState([]);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();

  const refresh = () => {
    setLoading(true);
    api.get("/garden").then((r) => setPlants(r.data)).finally(() => setLoading(false));
  };
  useEffect(() => { refresh(); }, []);

  const remove = async (p) => {
    await api.delete(`/garden/${p.id}`);
    setPlants((arr) => arr.filter((x) => x.id !== p.id));
    toast.message(`${p.name} removed.`);
  };

  return (
    <div className="space-y-8" data-testid="garden-page">
      <div className="flex flex-col md:flex-row md:items-end justify-between gap-4">
        <div>
          <div className="label-overline">My garden</div>
          <h1 className="font-serif text-4xl sm:text-5xl font-light tracking-tighter mt-1">
            The plants in your care.
          </h1>
          <p className="text-foreground/70 mt-3 max-w-xl">
            Each one becomes part of the Sage's counsel.
          </p>
        </div>
        <div className="flex gap-2">
          <AddCustomPlantDialog onCreated={(p) => setPlants((arr) => [p, ...arr])} />
          <Link to="/library">
            <Button className="bg-primary hover:bg-primary/90" data-testid="browse-library-btn">Browse library</Button>
          </Link>
        </div>
      </div>

      {loading ? (
        <div className="text-sm text-muted-foreground">Walking the rows…</div>
      ) : plants.length === 0 ? (
        <div
          className="rounded-lg border border-border overflow-hidden relative grain-overlay"
          style={{ minHeight: 320 }}
          data-testid="empty-garden"
        >
          <div className="absolute inset-0 bg-cover bg-center" style={{ backgroundImage: `url(${EMPTY_BG})` }} />
          <div className="absolute inset-0 bg-background/82" />
          <div className="relative p-10 max-w-xl">
            <div className="label-overline">Empty plot</div>
            <h3 className="font-serif text-3xl font-light mt-2">A garden waiting to be sown.</h3>
            <p className="text-foreground/70 mt-3">
              Add plants from the library or create your own — and the Sage will start whispering.
            </p>
            <div className="mt-5 flex gap-2">
              <Link to="/library"><Button className="bg-primary hover:bg-primary/90" data-testid="empty-library-btn">Browse library</Button></Link>
              <AddCustomPlantDialog onCreated={(p) => setPlants((arr) => [p, ...arr])} />
            </div>
          </div>
        </div>
      ) : (
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-5">
          {plants.map((p) => (
            <PlantCard
              key={p.id}
              plant={p}
              onClick={() => navigate(`/garden/${p.id}`)}
              onRemove={remove}
            />
          ))}
        </div>
      )}
    </div>
  );
}
